import { render, staticRenderFns } from "./ProjectImpactView.vue?vue&type=template&id=3ed4e6f2&scoped=true&"
import script from "./ProjectImpactView.vue?vue&type=script&lang=js&"
export * from "./ProjectImpactView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed4e6f2",
  null
  
)

export default component.exports